import Vue from 'vue';
import App from './App.vue';

import Element from 'element-ui';
import './styles/element-variables.scss';
import '@/styles/index.scss';

import store from './store';
import router from './router';
import i18n from './lang';
import './api';
import './icons';
import './permission' ;
import '@/components';
import './core/directives'
import Directives from './directives';
import { utilsOptionalChaining, handleLog } from "utils/index";
import localforage from 'localforage';

Vue.prototype.$$log = handleLog;
Vue.prototype.$localforage = localforage;

Vue.prototype.$globalLocalforage = localforage.createInstance({
	name: "ocs-log"
});
Vue.prototype.$iMLocalforage = localforage.createInstance({
	name: "im-chat"
});


import * as filters from './filters';
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$$ = utilsOptionalChaining;

Vue.use(Directives);
Vue.use(Element, {
	size: Cookies.get('size') || 'medium', // set element-ui default size
	i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueQuillEditor);
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]);
});

window.onerror = function(errorMessage, scriptURI, lineNo, columnNo, error) {
	Vue.prototype.$$log({
		category: "PvError", // 页面错误
		message: error, // 错误详情
	});
};

Vue.config.errorHandler = function (err, vm, info) {
	Vue.prototype.$$log({
		category: "PvError", // 页面错误
		message: err, // 错误详情
	});
}

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app');

// 改变国家语言配置
// i18n.locale = 'en'